// extracted by mini-css-extract-plugin
export default {"HealthCheckDetailDialog":"HealthCheckDetailDialog_HealthCheckDetailDialog__ijSMf"};